import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslateMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private readonly sub: Subscription;

  constructor(private readonly translate: TranslateService) {
    super();

    this.setLabels();

    this.sub = this.translate.onLangChange.subscribe(() => {
      this.setLabels();
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('material.paginator.rangePageEmpty', {
        length,
      });
    }

    const safeLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < safeLength ? Math.min(startIndex + pageSize, safeLength) : startIndex + pageSize;

    return this.translate.instant('material.paginator.rangePage', {
      startIndex: startIndex + 1,
      endIndex,
      length: safeLength,
    });
  };

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private setLabels(): void {
    this.itemsPerPageLabel = this.translate.instant('material.paginator.itemsPerPage');
    this.nextPageLabel = this.translate.instant('material.paginator.nextPage');
    this.previousPageLabel = this.translate.instant('material.paginator.previousPage');
    this.firstPageLabel = this.translate.instant('material.paginator.firstPage');
    this.lastPageLabel = this.translate.instant('material.paginator.lastPage');
  }
}

